import type { MouseEvent, ReactElement, ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BackButton } from "../../common-buttons/BackButton";
import { ContainerPreset } from "@/constants/componentPresets";
import { Ccontainer } from "../Ccontainer";
import { Cportal } from "../Cportal";
import { Cscrollable } from "../Cscrollable";
import { dataEl, type DataElScope } from "@/utils/dataEl";
import type { CrisingmodalContainerModel, CrisingmodalStyleModel, } from "./crisingmodalModel";
import { getBackButtonStyle } from "./crisingmodalModel";
import { DEFAULT_CARD_Y_OFFSET, SCROLLABLE_FADE_SIZE, } from "./crisingmodalConstants";
const WITH_BACK_BUTTON_VALUE = "with-back-button";
const PRIMARY_CARD_VALUE = "primary-card";
interface CrisingmodalViewProps {
    backButtonInset: string | number;
    children?: ReactNode;
    containerModel: CrisingmodalContainerModel;
    containerRadius: number;
    dataElScope: DataElScope;
    handleBack: () => void;
    handleClose: () => void;
    onExitComplete: () => void;
    padding: number;
    scrollRef?: React.RefObject<HTMLDivElement | null>;
    showBackButton: boolean;
    styleModel: CrisingmodalStyleModel;
    visible: boolean;
}
function stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
}
export function CrisingmodalView({ backButtonInset, children, containerModel, containerRadius, dataElScope, handleBack, handleClose, onExitComplete, padding, scrollRef, showBackButton, styleModel, visible, }: CrisingmodalViewProps): ReactElement {
    return (<Cportal>
      <AnimatePresence onExitComplete={onExitComplete}>
        {visible && (
            <motion.div data-el={dataEl(dataElScope, "Backdrop")} style={styleModel.overlayStyle} initial={{ opacity: 0 }} animate={{
                opacity: 1,
                transition: { duration: 0.2, ease: [0.4, 0, 0.2, 1] },
            }} exit={{
                opacity: 0,
                transition: { delay: 0.15, duration: 0.35, ease: [0.4, 0, 0.2, 1] },
            }} onClick={handleClose}>
              <Cscrollable dataElScope={dataElScope} fadeSize={SCROLLABLE_FADE_SIZE} scrollRef={scrollRef} style={styleModel.scrollableStyle}>
                <motion.div data-el={dataEl(dataElScope, "Card")} style={styleModel.cardMotionStyle} initial={{ opacity: 0, y: DEFAULT_CARD_Y_OFFSET }} animate={{
                opacity: 1,
                y: 0,
                transition: { duration: 0.35, ease: [0.4, 0, 0.2, 1] },
            }} exit={{
                opacity: 0,
                y: DEFAULT_CARD_Y_OFFSET,
                transition: { duration: 0.35, ease: [0.4, 0, 0.2, 1] },
            }}>
                  <div data-el={dataEl(dataElScope, "CardStack")} style={styleModel.cardStackStyle} onClick={stopPropagation}>
                    <Ccontainer preset={containerModel.preset} backgroundColor={containerModel.backgroundColor} backgroundOpacity={containerModel.backgroundOpacity} backdropBlur={containerModel.backdropBlur} radius={containerRadius} padding={padding} flexDirection="column" gap={24} boxShadow={containerModel.boxShadow} style={containerModel.style} contentWrapperStyle={styleModel.contentWrapperStyle}>
                      <div data-el={dataEl(dataElScope, "Content")} style={styleModel.contentStyle}>
                        {children}
                      </div>
                      {showBackButton && (<div data-el={dataEl(dataElScope, "BackButton")} style={getBackButtonStyle({ backButtonInset })}>
                          <BackButton onClick={handleBack}/>
                        </div>)}
                    </Ccontainer>
                  </div>
                </motion.div>
              </Cscrollable>
            </motion.div>
          )}
      </AnimatePresence>
    </Cportal>);
}
